module.exports = __webpack_public_path__ + "fonts/Inter-400-latin49.260c81a.woff2";